/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { ButtonFileUpload, DropdownFilterButton, useToastContext } from '@finbeat/react-toolkit';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import uploadFile from 'axios/fileUploadApi';
import useApi from 'hooks/useApi';
import { useTranslation } from 'react-i18next';
import { FileUploadNotificator, UploadResult } from 'utils/fileUploadNotificator';

const ButtonExcelFileUpload = ({
    controller,
    callback,
}: {
    controller: string;
    callback?: (res: UploadResult) => void;
}) => {
    const { t, i18n } = useTranslation();
    const toasts = useToastContext();
    const api = useApi();

    return (
        <ButtonFileUpload
            onFilesSelect={(files) => {
                const uploader = new FileUploadNotificator(
                    (file, onUploadProgress) =>
                        uploadFile(api, controller, file, onUploadProgress, {
                            culture: i18n.language,
                        }),
                    toasts,
                    callback
                );
                return uploader.uploadFiles(files);
            }}
            validate={(files) => {
                const extensions = ['xls', 'xlsx'];
                if (
                    Array.from(files).find((f) => !extensions.find((e) => f.name.endsWith('.' + e)))
                ) {
                    toasts.addToast({
                        title: t('BackOfficeToastHeaderWarning'),
                        type: 'warning',
                        autoDeleteTime: null,
                        description: t('BackOfficeFileImportExtensionError').replace(
                            '{0}',
                            extensions.join(', ')
                        ),
                    });

                    return false;
                }

                return true;
            }}
            button={(onClick, isUploading) => (
                <DropdownFilterButton
                    onClick={() => onClick()}
                    icon={faUpload}
                    title="BackOfficeUploadList"
                    disabled={isUploading}
                />
            )}
        />
    );
};

export default ButtonExcelFileUpload;
